import AccountTools from './accounts';
import DatabaseTools from './database';
import DeviceTools from './devices';
import events from 'lib/events';
import Inactive from './Accounts/Inactive';
import IntlWrapper from 'components/layout/intlWrapper';
import ProductUpdate from './Accounts/ProductUpdate';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import session from 'services/sessionService';
import {intlShape, injectIntl} from 'react-intl';
import {Header} from 'components/layout';
import {userLevels} from 'helpers/constants';
import QuickCalcs from './QuickCalcs';
import DealerApi from 'api/dealer';

let render = (container, params) => {
  console.info('[UI.page.tools] rendering page');

  ReactDOM.render(
    <IntlWrapper>
      <WrapperTools subPageName={params.subPage}
                    subSubPageName={params.subSubPage}
                    first={params.first}
                    second={params.second} />
    </IntlWrapper>,
    container);
  events.publish('page-change', {page: 'tools'});
};

console.info('[UI.page.tools] register route');
router.rr.add([{path: 'tools', handler: routeUtils.requireAuth(render)}]);
router.rr.add([{path: 'tools/:subPage/:subSubPage', handler: routeUtils.requireAuth(render)}]);
router.rr.add([{path: 'tools/:subPage', handler: routeUtils.requireAuth(render)}]);

// Page object
class Tools extends React.Component {
  static defaultProps = {
    subPageName: 'quick-calcs',
  };

  static displayName = 'Tools';

  static propTypes = {
    subPageName: PropTypes.string,
    subSubPageName: PropTypes.string,
    intl: intlShape,
  };

  state = {
    dealer: {},
  };

  componentWillMount() {
    const {formatMessage} = this.props.intl;

    DealerApi.getDealer(session.getUser().dealerId)
      .then(dealer => this.setState({dealer}))
      .catch(err => {
        console.error(err);

        events.publish('error.user', {message: formatMessage({id: 'general.error.retrieve.data'})});
      });
  }

  render() {
    let {formatMessage} = this.props.intl;
    let {subPageName, subSubPageName} = this.props;

    let subPages = {
      'quick-calcs': {name: formatMessage({id: 'quick-calcs.title'}), element: <QuickCalcs dealer={this.state.dealer} />,
        permissionLevel: userLevels.testStation},
      devices: {name: formatMessage({id: 'general.devices'}), element: <DeviceTools />, permissionLevel: userLevels.testStation},
      accounts: {name: formatMessage({id: 'general.accounts'}), element: <AccountTools />, permissionLevel: userLevels.testStation},
      database: {name: formatMessage({id: 'general.database'}), element: <DatabaseTools />, permissionLevel: userLevels.dealerAdmin},
    };

    let subSubPages = {
      accounts: {
        inactive: {name: 'Inactive', element: <Inactive />, permissionLevel: userLevels.manager},
        'product-update': {name: 'Product Update', element: <ProductUpdate />, permissionLevel: userLevels.dealerAdmin},
      },
    };

    let subPagesTabs = Object.keys(subPages)
      .filter(sp => subPages[sp].permissionLevel <= session.getUser().privileges.level)
      .map(sp => <a key={sp} className={subPageName === sp ? 'active' : ''}
                     href={'#tools/' + sp}>{subPages[sp].name}
      </a>);
    let subPage = '';

    if (subPages[subPageName].permissionLevel <= session.getUser().privileges.level) {
      subPage = subPages[subPageName].element;
    }

    if (subSubPageName && subPage && subSubPages[subPageName] && subSubPages[subPageName][subSubPageName] &&
        subSubPages[subPageName][subSubPageName].permissionLevel <= session.getUser().privileges.level) {
      subPage = subSubPages[subPageName][subSubPageName].element;
    }

    return (
      <div className='container nav-tabs'>
        <Header mainTitle={formatMessage({id: 'tools.title'})}/>
        <nav className='navigation-tabs'>
          {subPagesTabs}
        </nav>
        {subPage}
      </div>);
  }
}

const WrapperTools = injectIntl(Tools);

export default WrapperTools;
